import { httpClient } from '../http/httpClient'

export type MakeProposalRequest = {
  customerId: string
}

export type MakeProposalResponse = {
  contract: string
  reason_to_cancel: string
  value: number
  status: string
  statusAt: string
  history: any[]
  seller: string
  customer: any
  team: string
  table: string
  type: string
  _id: string
  createdAt: string
  updatedAt: string
  __v: number
}

export async function makeProposal(
  payload: MakeProposalRequest,
): Promise<MakeProposalResponse> {
  const { data } = await httpClient
    .post<MakeProposalResponse>('/pan', payload)
    .catch((error) => {
      throw error.response?.data ?? error
    })

  return data
}
